import { MenuItem, Select, Switch, Typography } from '@material-ui/core'
import React from 'react'
import { useBestPracticeManagementPanelStyles } from '../styles/useBestPracticeManagementPanelStyles'
import {
    parameterConfig,
    ParameterKey,
    ParameterOptionsMap,
    ParameterSelectedState,
    ParameterToggleState,
} from '../types/bpManagement.types'

interface ParameterListSectionProps {
    firmOptions: ParameterOptionsMap
    parameterToggles: ParameterToggleState
    parameterSelected: ParameterSelectedState
    onToggle: (key: ParameterKey) => void
    onSelectedChange: (key: ParameterKey, values: string[]) => void
}

export const ParameterListSection = ({
    firmOptions,
    parameterToggles,
    parameterSelected,
    onToggle,
    onSelectedChange,
}: ParameterListSectionProps) => {
    const classes = useBestPracticeManagementPanelStyles()

    return (
        <>
            {parameterConfig.map(({ key, label }) => {
                const allOptions = firmOptions[key]
                const selected = parameterSelected[key]
                const hasOptions = allOptions.length > 0
                const isOn = parameterToggles[key]
                return (
                    <div className={classes.parameterRow} key={key}>
                        <Typography className={classes.parameterLabel}>
                            {label}
                        </Typography>
                        {isOn && (
                            <Select
                                value={selected[0] || ''}
                                onChange={(e) => {
                                    const val = e.target.value as string
                                    onSelectedChange(key, val ? [val] : [])
                                }}
                                className={classes.select}
                                variant="outlined"
                            >
                                {allOptions.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                        <Switch
                            checked={isOn}
                            onChange={() => onToggle(key)}
                            color="primary"
                            size="small"
                            disabled={!hasOptions}
                        />
                    </div>
                )
            })}
        </>
    )
}
